import { render } from "./Faq.vue?vue&type=template&id=e97af596"
const script = {}
script.render = render

export default script